module.exports = __webpack_public_path__ + "static/media/email-light.0a0616e3.svg";